<template src="./index.pug" lang="pug"></template>

<script>
import moment from 'moment'
import vSelect from 'vue-select'
import Draggable from 'vuedraggable'
import Dashboard from '../../dashboard/Dashboard'
import { getCharts } from './config'
import language from '../../../../build/language/index'
import GraficoIdEnum from '../../../enum/graficoId'
import FiltroPeriodoEnum from '../../../enum/filtroPeriodo'

export default {
  name: 'Index',

  components: {
    vSelect,
    Draggable,
    Dashboard
  },

  data () {
    return {
      doneLoading: false,
      clientId: null,
      windowWidth: null,
      minWindowWidth: 1024,
      itermedWindowWidth: 1320,
      intervalLoadGadgets: null,
      isLoadingGadgets: false,
      view: false,
      gadgets: [],
      charts: getCharts(),
      dashboardCharts: [],
      hasPendingRequest: false,
      canLoad: {
        ChartConciliationSituationSummary: {
          state: false,
          alreadyLoaded: false,
          load: this.loadDataConciliationSituationSummary,
          currentRequest: null
        },
        DailyBankStatment: {
          state: false,
          alreadyLoaded: false,
          load: this.loadDataDailyBankStatment,
          currentRequest: null
        },
        ChartAllotmentDistributionConciliation: {
          state: false,
          alreadyLoaded: false,
          load: this.loadBatchReconciliationDistribution,
          currentRequest: null
        },
        GadgetTasks: {
          state: false,
          alreadyLoaded: false,
          load: this.loadDataTasks,
          currentRequest: null
        },
        ChartFinancialSummary: {
          state: false,
          alreadyLoaded: false,
          load: this.loadDataFinancialSummary,
          currentRequest: null
        },
        DigitalWalletBalance: {
          state: false,
          alreadyLoaded: false,
          load: this.loadDataDigitalWalletBalance,
          currentRequest: null
        }
      }
    }
  },

  computed: {
    /* Globais */

    client () {
      return this.$store.getters.client
    },

    allowedFuncionalities () {
      return this.$store.getters.allowedFuncionalities
    },

    isLoadingDataGeneral () {
      return this.$store.getters.isLoadingData
    },

    availableGadgets () {
      return this.$store.getters.availableGadgets
    },

    /* Filtros do gráfico Distribuição de conciliação */

    periodFilterConcSitSummary () {
      return this.$store.getters.periodFilterConcSitSummary
    },

    planSelectedFilterConcSitSummary () {
      return this.$store.getters.planSelectedFilterConcSitSummary
    },

    typeFilterConcSituationSummary () {
      return this.$store.getters.typeFilterConcSituationSummary
    },

    mainCategorySelectedFilterConcSitSummary () {
      return this.$store.getters.mainCategorySelectedFilterConcSitSummary
    },

    /* Filtros do gráfico Lançamentos conciliados */

    periodFilterAllotmentDistribution () {
      return this.$store.getters.periodFilterAllotmentDistribution
    },

    planSelectedFilterBatch () {
      return this.$store.getters.planSelectedFilterBatch
    },

    typeSelectedFilterBatch () {
      return this.$store.getters.typeSelectedFilterBatch
    },

    mainCategorySelectedFilterBatch () {
      return this.$store.getters.mainCategorySelectedFilterBatch
    },

    /* Filtros do gráfico Resumo financeiro */

    periodFilterFinancialSummary () {
      return this.$store.getters.periodFilterFinancialSummary
    },

    mainCategorySelectedFilterFinancialSummary () {
      return this.$store.getters.mainCategorySelectedFilterFinancialSummary
    },

    /* Filtros do gráfico Saldo bancário */

    periodFilterBankBalance () {
      return this.$store.getters.periodFilterBankBalance
    },

    accountSelectedBankBalance () {
      return this.$store.getters.accountSelectedBankBalance
    },

    /* Filtros do gráfico Saldo carteira digital */

    periodFilterDigitalWalletBalance () {
      return this.$store.getters.periodFilterDigitalWalletBalance
    },

    categorySelectedDigitalWalletBalance () {
      return this.$store.getters.categorySelectedDigitalWalletBalance
    }
  },

  watch: {
    /* Globais */

    client () {
      this.loadHome()
    },

    canLoad: {
      handler () {
        for (const key in this.canLoad) {
          if (this.canLoad[key].alreadyLoaded) {
            continue
          }
          if (this.canLoad[key].state) {
            this.canLoad[key].load()
          } else {
            this.stopLoadingGadget(key)
          }
        }
      },
      deep: true
    },

    /* Filtros do gráfico Distribuição de conciliação */

    periodFilterConcSitSummary: {
      handler (newVal, oldVal) {
        let isNewisNewLoading = newVal.id !== oldVal.id ||
        (
          newVal.id === FiltroPeriodoEnum.PERSONALIZADO &&
          (
            newVal.fromDate !== oldVal.fromDate ||
            newVal.toDate !== oldVal.toDate
          )
        )
        this.handleConciliationSituationSummary(!isNewisNewLoading)
      },
      deep: true
    },

    planSelectedFilterConcSitSummary: {
      handler (newVal, oldVal) {
        this.handleConciliationSituationSummary(newVal.id === oldVal.id)
      },
      deep: true
    },

    typeFilterConcSituationSummary: {
      handler (newVal, oldVal) {
        this.handleConciliationSituationSummary(newVal.id === oldVal.id)
      },
      deep: true
    },

    mainCategorySelectedFilterConcSitSummary: {
      handler (newVal, oldVal) {
        this.handleConciliationSituationSummary(newVal.id === oldVal.id)
      },
      deep: true
    },

    /* Filtros do gráfico Lançamentos conciliados */

    periodFilterAllotmentDistribution: {
      handler (newVal, oldVal) {
        let isNewisNewLoading = newVal.id !== oldVal.id ||
        (
          newVal.id === FiltroPeriodoEnum.PERSONALIZADO &&
          (
            newVal.fromDate !== oldVal.fromDate ||
            newVal.toDate !== oldVal.toDate
          )
        )
        this.handleReconciliationDistribution(!isNewisNewLoading)
      },
      deep: true
    },

    planSelectedFilterBatch: {
      handler (newVal, oldVal) {
        this.handleReconciliationDistribution(newVal.id === oldVal.id)
      },
      deep: true
    },

    typeSelectedFilterBatch: {
      handler (newVal, oldVal) {
        this.handleReconciliationDistribution(newVal.id === oldVal.id)
      },
      deep: true
    },

    mainCategorySelectedFilterBatch: {
      handler (newVal, oldVal) {
        this.handleReconciliationDistribution(newVal.id === oldVal.id)
      },
      deep: true
    },

    /* Filtros do gráfico Resumo financeiro */

    periodFilterFinancialSummary: {
      handler (newVal, oldVal) {
        const currentRequest = this.canLoad.ChartFinancialSummary.currentRequest
        let isNewLoading = true
        if (currentRequest) {
          if (currentRequest.periodo === newVal.id && newVal.id === FiltroPeriodoEnum.PERSONALIZADO) {
            if (newVal.fromDate !== currentRequest.dataInicio || newVal.toDate !== currentRequest.dataFim) {
              this.canLoad.ChartFinancialSummary.currentRequest = null
            } else {
              isNewLoading = false
            }
          } else if (currentRequest.periodo === newVal.id) {
            return
          } else {
            this.canLoad.ChartFinancialSummary.currentRequest = null
          }
        }
        this.canLoad.ChartFinancialSummary.alreadyLoaded = !isNewLoading
        this.canLoad.ChartFinancialSummary.state = this.periodFilterFinancialSummary && this.periodFilterFinancialSummary.id
      },
      deep: true
    },

    mainCategorySelectedFilterFinancialSummary: {
      handler (newVal, oldVal) {
        this.handleFinancialSummary(newVal.id === oldVal.id)
      },
      deep: true
    },

    /* Filtros do gráfico Saldo bancário */

    periodFilterBankBalance: {
      handler (newVal, oldVal) {
        let isNewisNewLoading = newVal.id !== oldVal.id ||
        (
          newVal.id === FiltroPeriodoEnum.PERSONALIZADO &&
          (
            newVal.fromDate !== oldVal.fromDate ||
            newVal.toDate !== oldVal.toDate
          )
        )
        this.handleBankBalance(!isNewisNewLoading)
      },
      deep: true
    },

    accountSelectedBankBalance: {
      handler (newVal, oldVal) {
        this.handleBankBalance(newVal.id === oldVal.id)
      },
      deep: true
    },

    /* Filtros do gráfico Saldo carteira digital */

    periodFilterDigitalWalletBalance: {
      handler (newVal, oldVal) {
        let isNewisNewLoading = newVal.id !== oldVal.id ||
        (
          newVal.id === FiltroPeriodoEnum.PERSONALIZADO &&
          (
            newVal.fromDate !== oldVal.fromDate ||
            newVal.toDate !== oldVal.toDate
          )
        )
        this.handleDigitalWalletBalance(!isNewisNewLoading)
      },
      deep: true
    },

    categorySelectedDigitalWalletBalance: {
      handler (newVal, oldVal) {
        this.handleDigitalWalletBalance(newVal.id === oldVal.id)
      },
      deep: true
    }
  },

  methods: {
    /* Globais */

    loadHome () {
      this.resetGadgets()
      this.hasPendingRequest = true
      this.$store.dispatch('loadingData').then(() => {
        this.loadGadgets().then(() => {
          this.canLoad.GadgetTasks.state = true
          this.hasPendingRequest = false
          this.$store.dispatch('dataLoaded')
        })
      })
    },

    loadGadgets () {
      const self = this
      return new Promise((resolve, reject) => {
        Promise.all([this.loadPlans(), this.loadMainCategories()])
          .then(() => {
            self.$store.dispatch('getGadgets')
              .then((response) => {
                self.handleGadgetsChange()
                resolve()
              }).catch(() => {
                self.gadgets = []
                self.view = false
                reject()
              })
          }).catch((error) => {
            reject(error)
          })
      })
    },

    handleGadgetsChange () {
      this.view = false
      this.windowWidth = window.innerWidth

      this.dashboardCharts = []

      if (!this.intervalLoadGadgets) {
        this.intervalLoadGadgets = setInterval(function () {
          if (!this.hasPendingRequest && this.allowedFuncionalities && this.allowedFuncionalities.length > 0) {
            this.loadHome()
          }
        }.bind(this), 600000)
      }

      for (const gadget of this.availableGadgets) {
        let idGadget = gadget.funcionalidade.idFuncionalidade
        let container = null
        let order = null

        if (gadget && gadget.gadgetParam && gadget.gadgetParam.length > 0) {
          // Pega a configuração de qual container está
          container = Number(gadget.gadgetParam.find(param => param.nome === 'container').valor)

          // Pega a configuração de ordem
          order = gadget.gadgetParam.find(param => param.nome === 'ordemExibicao').valor
        }

        // Encontra o gráfico pelo id, para setar as configurações
        const index = this.charts.findIndex(chart => chart.idChart === idGadget)
        if (index === -1) {
          continue
        }
        const chartFound = this.charts[index]
        chartFound.container = container === 1 ? 'chartFull' : 'chartMiddle'
        chartFound.order = Number(order)

        this.dashboardCharts.push(chartFound)
        this.canLoad[chartFound.idChartTemplate].state = true
      }
      this.dashboardCharts.sort((a, b) => a.order - b.order)
      this.doneLoading = true
      this.view = this.availableGadgets.length > 0
      this.$store.dispatch('setDashboardDateFilter', {
        id: FiltroPeriodoEnum.ULTIMOS_TRINTA_DIAS,
        label: this.$t('dashboard.filtro.data.ultimosTrintaDias')
      })
    },

    stopLoadingGadget (idChart) {
      const chartConfig = this.charts.find(chart => chart.idChartTemplate === idChart)
      if (chartConfig.series) {
        chartConfig.series = []
      }
      if (chartConfig.xAxis) {
        chartConfig.xAxis.categories = []
      }
      chartConfig.isLoadingData = false
    },

    resetGadgets () {
      this.$store.dispatch('cancelDashboardRequests')
      this.gadgets = []
      this.view = false
      clearInterval(this.intervalLoadGadgets)
      this.intervalLoadGadgets = null
      for (const key in this.canLoad) {
        this.canLoad[key].alreadyLoaded = false
        this.canLoad[key].state = false
      }
    },

    loadPlans () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('getPlans', '/dashboard/listPlans').then((response) => {
          this.$store.dispatch('setPlansDashboard', response.data.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },

    loadMainCategories () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('getMainCategories', '/dashboard/listMainCategories').then((response) => {
          this.$store.dispatch('setMainCategoriesDashboard', response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },

    /* Gráfico Distribuição de conciliação */

    handleConciliationSituationSummary (alreadyLoaded) {
      const currentRequest = this.canLoad.ChartConciliationSituationSummary.currentRequest
      if (currentRequest) {
        if (currentRequest.idPlanoConciliacao === this.planSelectedFilterConcSitSummary.id &&
          (currentRequest.tipo || 'TD') === this.typeFilterConcSituationSummary.id &&
          (currentRequest.idCategoriaPai || 'TD') === this.mainCategorySelectedFilterConcSitSummary.id &&
          alreadyLoaded) {
          return
        }
        this.canLoad.ChartConciliationSituationSummary.currentRequest = null
      }
      this.canLoad.ChartConciliationSituationSummary.alreadyLoaded = alreadyLoaded
      this.canLoad.ChartConciliationSituationSummary.state = this.periodFilterConcSitSummary &&
        this.periodFilterConcSitSummary.id &&
        this.planSelectedFilterConcSitSummary &&
        this.planSelectedFilterConcSitSummary.id &&
        this.typeFilterConcSituationSummary &&
        this.typeFilterConcSituationSummary.id &&
        this.mainCategorySelectedFilterConcSitSummary &&
        this.mainCategorySelectedFilterConcSitSummary.id
    },

    loadDataConciliationSituationSummary () {
      const self = this
      return new Promise((resolve, reject) => {
        // Verifica se possui permissão na lista de gadgets disponíveis
        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.RESUMO_SITUACAO_CONCILIACAO)
        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'ChartConciliationSituationSummary')

        if (!gadget || !self.planSelectedFilterConcSitSummary.id || !self.periodFilterConcSitSummary.id) {
          chartConfig.series = []
          chartConfig.xAxis.categories = []
          chartConfig.isLoadingData = false
          return resolve()
        }

        self.canLoad.ChartConciliationSituationSummary.alreadyLoaded = true

        chartConfig.isLoadingData = true
        const filterConciliationSituationSummary = {
          idPlanoConciliacao: self.planSelectedFilterConcSitSummary.id,
          tipo: self.typeFilterConcSituationSummary.id !== 'TD' ? self.typeFilterConcSituationSummary.id : null,
          idCategoriaPai: self.mainCategorySelectedFilterConcSitSummary.id !== 'TD' ? self.mainCategorySelectedFilterConcSitSummary.id : null,
          periodo: self.periodFilterConcSitSummary.id,
          dataInicio: self.periodFilterConcSitSummary.fromDate,
          dataFim: self.periodFilterConcSitSummary.toDate,
          lang: language.getCookieByName('language')
        }

        self.canLoad.ChartConciliationSituationSummary.currentRequest = filterConciliationSituationSummary

        self.$store.dispatch('getDataConciliationSituationSummary', filterConciliationSituationSummary)
          .then((response) => {
            chartConfig.series = response.data.series
            chartConfig.xAxis.categories = response.data.xAxis
            resolve()
          }).catch(() => {
            chartConfig.series = []
            chartConfig.xAxis.categories = []
            reject()
          }).finally(() => {
            chartConfig.isLoadingData = false
          })
      })
    },

    /* Gráfico Lançamentos conciliados */

    handleReconciliationDistribution (alreadyLoaded) {
      const currentRequest = this.canLoad.ChartAllotmentDistributionConciliation.currentRequest
      if (currentRequest) {
        if (currentRequest.idPlanoConciliacao === this.planSelectedFilterBatch.id &&
          (currentRequest.tipo || 'TD') === this.typeSelectedFilterBatch.id &&
          (currentRequest.idCategoriaPai || 'TD') === this.mainCategorySelectedFilterBatch.id &&
          alreadyLoaded) {
          return
        }
        this.canLoad.ChartAllotmentDistributionConciliation.currentRequest = null
      }
      this.canLoad.ChartAllotmentDistributionConciliation.alreadyLoaded = alreadyLoaded
      this.canLoad.ChartAllotmentDistributionConciliation.state = this.periodFilterAllotmentDistribution && this.periodFilterAllotmentDistribution.id &&
        this.planSelectedFilterBatch && this.planSelectedFilterBatch.id &&
        this.typeSelectedFilterBatch && this.typeSelectedFilterBatch.id &&
        this.mainCategorySelectedFilterBatch && this.mainCategorySelectedFilterBatch.id
    },

    loadBatchReconciliationDistribution () {
      const self = this
      return new Promise((resolve, reject) => {
        // Verifica se possui permissão na lista de gadgets disponíveis
        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.DISTRIBUICAO_CONCILIACAO_LOTE)
        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'ChartAllotmentDistributionConciliation')

        if (!gadget || !self.periodFilterAllotmentDistribution.id || !self.planSelectedFilterBatch.id) {
          chartConfig.series = []
          chartConfig.isLoadingData = false
          self.isLoadingDataBatchReconciliationDistribution = false
          return resolve()
        }

        self.canLoad.ChartAllotmentDistributionConciliation.alreadyLoaded = true

        chartConfig.isLoadingData = true
        const filterAllotmentDistribution = {
          idPlanoConciliacao: self.planSelectedFilterBatch.id,
          tipo: self.typeSelectedFilterBatch.id !== 'TD' ? self.typeSelectedFilterBatch.id : null,
          idCategoriaPai: self.mainCategorySelectedFilterBatch.id !== 'TD' ? self.mainCategorySelectedFilterBatch.id : null,
          periodo: self.periodFilterAllotmentDistribution.id,
          dataInicio: self.periodFilterAllotmentDistribution.fromDate,
          dataFim: self.periodFilterAllotmentDistribution.toDate,
          lang: language.getCookieByName('language')
        }

        self.canLoad.ChartAllotmentDistributionConciliation.currentRequest = filterAllotmentDistribution

        self.$store.dispatch('getDataAllotmentDistributionSummary', filterAllotmentDistribution)
          .then(response => {
            chartConfig.series = response.data.series
            resolve()
          })
          .catch(() => {
            chartConfig.series = []
            reject()
          })
          .finally(() => {
            chartConfig.isLoadingData = false
          })
      })
    },

    /* Gráfico Resumo financeiro */

    handleFinancialSummary (alreadyLoaded) {
      const currentRequest = this.canLoad.ChartFinancialSummary.currentRequest
      if (currentRequest) {
        if ((currentRequest.idCategoriaPai || 'TD') === this.mainCategorySelectedFilterFinancialSummary.id &&
          alreadyLoaded) {
          return
        }
        this.canLoad.ChartFinancialSummary.currentRequest = null
      }
      this.canLoad.ChartFinancialSummary.alreadyLoaded = alreadyLoaded
      this.canLoad.ChartFinancialSummary.state = this.periodFilterFinancialSummary &&
        this.periodFilterFinancialSummary.id &&
        this.mainCategorySelectedFilterFinancialSummary &&
        this.mainCategorySelectedFilterFinancialSummary.id
    },

    loadDataFinancialSummary () {
      const self = this
      return new Promise((resolve, reject) => {
        // Verifica se possui permissão na lista de gadgets disponíveis
        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.RESUMO_FINANCEIRO_PLANO_CONCILIACAO)
        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'ChartFinancialSummary')

        if (!gadget || !self.periodFilterFinancialSummary.id) {
          chartConfig.isLoadingData = false
          chartConfig.series = []
          chartConfig.xAxis.categories = []
          return resolve()
        }

        self.canLoad.ChartFinancialSummary.alreadyLoaded = true

        chartConfig.isLoadingData = true
        const filterFinancialSummary = {
          tipo: 'MF',
          idCategoriaPai: self.mainCategorySelectedFilterFinancialSummary.id !== 'TD' ? self.mainCategorySelectedFilterFinancialSummary.id : null,
          periodo: self.periodFilterFinancialSummary.id,
          dataInicio: self.periodFilterFinancialSummary.fromDate,
          dataFim: self.periodFilterFinancialSummary.toDate,
          lang: language.getCookieByName('language')
        }

        self.canLoad.ChartFinancialSummary.currentRequest = filterFinancialSummary

        self.$store.dispatch('getDataFinancialSummary', filterFinancialSummary)
          .then((response) => {
            chartConfig.series = response.data.series
            chartConfig.xAxis.categories = response.data.xAxis
            resolve()
          }).catch(() => {
            chartConfig.series = []
            chartConfig.xAxis.categories = []
            reject()
          })
          .finally(() => {
            chartConfig.isLoadingData = false
          })
      })
    },

    /* Gráfico Saldo bancário */

    handleBankBalance (alreadyLoaded) {
      const currentRequest = this.canLoad.DailyBankStatment.currentRequest
      if (currentRequest) {
        if (currentRequest.idConta === this.accountSelectedBankBalance.id && alreadyLoaded) {
          return
        }
        this.canLoad.DailyBankStatment.currentRequest = null
      }
      this.canLoad.DailyBankStatment.alreadyLoaded = alreadyLoaded
      this.canLoad.DailyBankStatment.state = this.periodFilterBankBalance && this.periodFilterBankBalance.id && this.accountSelectedBankBalance && typeof this.accountSelectedBankBalance.id !== 'undefined'
    },

    loadDataDailyBankStatment () {
      const self = this
      return new Promise((resolve, reject) => {
        // Verifica se possui permissão na lista de gadgets disponíveis
        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.SALDO_BANCARIO)
        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'DailyBankStatment')

        if (!gadget || !self.periodFilterBankBalance.id || typeof self.accountSelectedBankBalance.id === 'undefined') {
          chartConfig.series = []
          chartConfig.xAxis.categories = []
          chartConfig.isLoadingData = false
          return resolve()
        }

        self.canLoad.DailyBankStatment.alreadyLoaded = true

        let idGrupo
        // Tratamento para mandar 0 para o MS ao inves de -1
        if (self.accountSelectedBankBalance.tipo === 'GRUPO') {
          idGrupo = self.accountSelectedBankBalance.id > 0 ? self.accountSelectedBankBalance.id : 0
        }

        chartConfig.isLoadingData = true
        const filterDailyBank = {
          idConta: (self.accountSelectedBankBalance.tipo === 'CONTA_BANCARIA') ? self.accountSelectedBankBalance.id : null,
          idGrupo: (self.accountSelectedBankBalance.tipo === 'GRUPO') ? idGrupo : null,
          periodo: self.periodFilterBankBalance.id,
          dataInicio: self.periodFilterBankBalance.fromDate,
          dataFim: self.periodFilterBankBalance.toDate,
          lang: language.getCookieByName('language')
        }

        self.canLoad.DailyBankStatment.currentRequest = filterDailyBank

        this.$store.dispatch('getDataDailyBankStatment', filterDailyBank)
          .then(response => {
            chartConfig.series = response.data.series
            chartConfig.xAxis.categories = response.data.xAxis
            resolve()
          })
          .catch((error) => {
            chartConfig.series = []
            chartConfig.xAxis.categories = []
            if (error && error.message === 'user.cancelled') {
              resolve()
            } else {
              reject()
            }
          }).finally(() => {
            chartConfig.isLoadingData = false
          })
      })
    },

    /* Gráfico de tarefas */

    loadDataTasks () {
      const self = this
      return new Promise((resolve, reject) => {
        // Verifica se possui permissão na lista de gadgets disponíveis
        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.GADGET_TAREFAS)
        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'GadgetTasks')

        if (!gadget) {
          return resolve()
        }

        self.canLoad.GadgetTasks.alreadyLoaded = true

        chartConfig.isLoadingData = true
        self.$store.dispatch('getDataTasks')
          .then(response => {
            const tasks = response.data
            tasks.dataProximoVencimento = tasks.dataProximoVencimento ? moment(tasks.dataProximoVencimento).format('L') : null
            chartConfig.data = tasks
            resolve()
          })
          .catch(() => {
            reject()
          }).finally(() => {
            chartConfig.isLoadingData = false
          })
      })
    },

    /* Gráfico Saldo carteira digital */

    handleDigitalWalletBalance (alreadyLoaded) {
      const currentRequest = this.canLoad.DigitalWalletBalance.currentRequest
      if (currentRequest) {
        if (currentRequest.idCategoria === this.categorySelectedDigitalWalletBalance.id && alreadyLoaded) {
          return
        }
        this.canLoad.DigitalWalletBalance.currentRequest = null
      }
      this.canLoad.DigitalWalletBalance.alreadyLoaded = alreadyLoaded
      this.canLoad.DigitalWalletBalance.state = this.periodFilterDigitalWalletBalance && this.periodFilterDigitalWalletBalance.id && this.categorySelectedDigitalWalletBalance && typeof this.categorySelectedDigitalWalletBalance.id !== 'undefined'
    },

    loadDataDigitalWalletBalance () {
      const self = this
      return new Promise((resolve, reject) => {
        // Verifica se possui permissão na lista de gadgets disponíveis
        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.SALDO_CARTEIRA_DIGITAL)
        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'DigitalWalletBalance')

        if (!gadget || !self.periodFilterDigitalWalletBalance.id || typeof self.categorySelectedDigitalWalletBalance.id === 'undefined') {
          chartConfig.series = []
          chartConfig.xAxis.categories = []
          chartConfig.isLoadingData = false
          return resolve()
        }

        self.canLoad.DigitalWalletBalance.alreadyLoaded = true

        chartConfig.isLoadingData = true
        const filterDigitalWalletBalance = {
          idCategoria: self.categorySelectedDigitalWalletBalance.id !== 'TD' ? self.categorySelectedDigitalWalletBalance.id : null,
          periodo: self.periodFilterDigitalWalletBalance.id,
          dataInicio: self.periodFilterDigitalWalletBalance.fromDate,
          dataFim: self.periodFilterDigitalWalletBalance.toDate,
          lang: language.getCookieByName('language')
        }

        self.canLoad.DigitalWalletBalance.currentRequest = filterDigitalWalletBalance

        this.$store.dispatch('getDataDigitalWalletBalance', filterDigitalWalletBalance)
          .then(response => {
            chartConfig.series = response.data.series
            chartConfig.xAxis.categories = response.data.xAxis
            resolve()
          })
          .catch((error) => {
            chartConfig.series = []
            chartConfig.xAxis.categories = []
            if (error && error.message === 'user.cancelled') {
              resolve()
            } else {
              reject()
            }
          }).finally(() => {
            chartConfig.isLoadingData = false
          })
      })
    }
  },

  mounted () {
    if (this.client && this.allowedFuncionalities && this.allowedFuncionalities.length > 0) {
      this.loadHome()
    }
  },

  beforeDestroy () {
    this.$store.dispatch('cleanGadgetsFilters')
  }
}
</script>

<style>
.isLoadingDataGeneral {
  background: url(../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;
  background-color: #EEE;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  opacity: 0.8;
  overflow-y: hidden;
  cursor: wait;
  background-size: 150px;
  -webkit-transition: all 5s ease-in-out;
  -moz-transition: all 5s ease-in-out;
  -ms-transition: all 5s ease-in-out;
  -o-transition: all 5s ease-in-out;
  transition: all 5s ease-in-out;
}

.inicial-bg {
  height: 80vh;
  background: url(../../../assets/logos_equals/logo_equals_inicial.svg) center no-repeat;
  margin: auto;
  position: absolute;
  right: 40vw;
}

.highcharts-no-data>span {
  font-family: 'Inter', sans-serif !important;
  font-size: 18px !important;
  text-align: center;
  color: #4a4a4a;
}

.highcharts-no-data>span>i {
  font-size: 6em;
  color: rgba(119, 119, 119, 0.35);
  padding-bottom: 40px;
}

.highcharts-button {
  cursor: pointer!important;
}

.highcharts-yaxis .highcharts-axis-line {
  stroke-width: 2px;
}

@media sen and (min-width: 992px) {
  .inicial-bg {
    width: 20%;
  }
}

@media screen and (max-width: 991px) and (min-width: 560px) {
  .inicial-bg {
    width: 40%;
  }
}

@media screen and (max-width: 559px) {
  .inicial-bg {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// Index.vue?78cf4451